import '@splidejs/splide/dist/js/splide.min';
import '@splidejs/splide-extension-auto-scroll/dist/js/splide-extension-auto-scroll.min';
import 'isotope-layout/dist/isotope.pkgd.min';

import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';


// //import light gallery
// import lightGallery from 'lightgallery';
// import lgThumbnail from 'lightgallery/plugins/thumbnail'
// import lgZoom from 'lightgallery/plugins/zoom' 
// // Light Gallery component imported from assets folder
// import {inlineGalleryFunction} from '../assets/js/lg-init' ;
// inlineGalleryFunction(lightGallery, lgThumbnail, lgZoom);

// Import micromodal
import micromodal from 'micromodal/dist/micromodal.min';

// Swiper Sliders
import Swiper from 'swiper/bundle';
import initSwiperGallery from './modules/swiper-gallery'
import heroSlider from './modules/hero-swiper-slider'

// Special Slider component imported from assets folder
import {specialSlider, logoSlider, homeSpecialSlider} from '../assets/js/splide-slider';

// Special Slider component imported from assets folder

specialSlider(Splide, AutoScroll);
logoSlider(Splide, AutoScroll);
homeSpecialSlider(Splide);

// jQuery 
jQuery(document).ready(function ($) {

    $('.isotope').isotope({
        itemSelector: '.isotope-item',
    });

    // filter items on button click
    $('.filter-button-group').on('click', 'li', function () {
        var filterValue = $(this).attr('data-filter');
        $('.isotope').isotope({filter: filterValue});
        $('.filter-button-group li').removeClass('active');
        $(this).addClass('active');
    });
})


import {Carousel, Tabs} from 'flowbite';

// if any element with id that contains 'carousel' is found, initialize carousel
if (document.querySelector('[id^="carousel"]')) {
    const items = [
        {
            position: 0,
            el: document.getElementById('carousel-item-1')
        },
        {
            position: 1,
            el: document.getElementById('carousel-item-2')
        },
        {
            position: 2,
            el: document.getElementById('carousel-item-3')
        },
        {
            position: 3,
            el: document.getElementById('carousel-item-4')
        },
    ];

    const options = {
        defaultPosition: 1,
        interval: 3000,

        indicators: {
            activeClasses: 'bg-white dark:bg-gray-800',
            inactiveClasses: 'bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800',
            items: [
                {
                    position: 0,
                    el: document.getElementById('carousel-indicator-1')
                },
                {
                    position: 1,
                    el: document.getElementById('carousel-indicator-2')
                },
                {
                    position: 2,
                    el: document.getElementById('carousel-indicator-3')
                },
                {
                    position: 3,
                    el: document.getElementById('carousel-indicator-4')
                },
            ]
        },

        // callback functions
        onNext: () => {
            console.log('next slider item is shown');
        },
        onPrev: () => {
            console.log('previous slider item is shown');
        },
        onChange: () => {
            console.log('new slider item has been shown');
        }
    };

    const carousel = new Carousel(items, options);

    const $prevButton = document.getElementById('data-carousel-prev');
    const $nextButton = document.getElementById('data-carousel-next');

    $prevButton.addEventListener('click', () => {
        carousel.prev();
    });

    $nextButton.addEventListener('click', () => {
        carousel.next();
    });
}


/* Flowbite Tabs */
// create an array of objects with the id, trigger element (eg. button), and the content element

// get all elements with an id that starts with 'tab-'
const tabElements = Array.from(document.querySelectorAll('[data-tab^="tab-"]')).map((el) => {
    return {
        id: el.getAttribute('data-tab'),
        triggerEl: document.querySelector(`#${el.getAttribute('data-tab')}-tab-button`),
        targetEl: document.querySelector(`#${el.getAttribute('data-tab')}-content`)
    }
});

// options with default values
const tab_options = {
    defaultTabId: 'profile',
    activeClasses: 'text-accent hover:text-accent border-accent',
    inactiveClasses: 'text-gray-500 hover:text-gray-600 border-gray-100 hover:border-gray-300',
    onShow: () => {
        console.log('tab is shown');
    }
};


/*
* tabElements: array of tab objects
* options: optional
*/
const tabs = new Tabs(tabElements, tab_options);

// shows another tab element
// tabs.show('profile');

// get the tab object based on ID
// tabs.getTab('contacts')


// get the current active tab object
// tabs.getActiveTab()

// when <select> with id = tabs is changed, show the selected tab
if (document.getElementById('tabs')) {
    document.getElementById('tabs').addEventListener('change', (e) => {
        tabs.show(e.target.value);
    });
}

/* Auto Grid Custom JS */
document.addEventListener('DOMContentLoaded', () => {
    const gridContainers = document.getElementsByClassName("auto-grid");
    for (const gridContainer of gridContainers) {
        const itemCount = gridContainer.childElementCount;

        // if itemCount is less than 3, apply the new column rules
        if (itemCount < 3) {
            gridContainer.classList.remove("md:grid-cols-3");
            gridContainer.classList.remove("grid-cols-2");

            gridContainer.classList.add(`md:grid-cols-${itemCount}`);
            gridContainer.classList.add(`grid-cols-${itemCount - 1}`);
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const usedCarSliderElement = document.querySelector('.mainSlider');
    const heroSliderElement = document.querySelector('.hero-slider');

    // load only when used car slider element loaded
    if (usedCarSliderElement) {
        initSwiperGallery(Swiper);
    }

    if (heroSliderElement) {
        heroSlider(Swiper);
    }
});
